// extracted by mini-css-extract-plugin
export default {"overlay":"AnalyzingOverlay_overlay__1XzmT","spinner":"AnalyzingOverlay_spinner__Zmwca","spin":"AnalyzingOverlay_spin__mdyXL","text":"AnalyzingOverlay_text__WprtV"};